export class TreeService {
  public structureNodeToNode(structureNode: any, selectedId?: number, parent?: any): any {
    const node: any = {
      id: structureNode.id,
      text: structureNode.name,
      isLeaf: !structureNode.hasChildren,
      selected: structureNode.id === selectedId,
      parent
    };
    node.children = structureNode.children ? structureNode.children.map((child: any) => this.structureNodeToNode(child, selectedId, node)) : [];
    node.opened = node.children.some((child: any) => child.opened || child.selected);
    return node;
  }
}

export default new TreeService();
